import { render } from "./PantryUsedUpCheckPage.vue?vue&type=template&id=13071011&ts=true"
import script from "./PantryUsedUpCheckPage.vue?vue&type=script&lang=ts"
export * from "./PantryUsedUpCheckPage.vue?vue&type=script&lang=ts"

import "./PantryUsedUpCheckPage.vue?vue&type=style&index=0&id=13071011&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__